<!-- my-loader.component.html -->
<div class="progress-loader centered" [hidden]="!showSpinner">
    <div class="loading-spinner centered">
        <img src="../../../assets/gif/{{spinnerImage}}">
        <span class="text-centered">{{spinnerText}}</span>
        <span style="color: red; font-size: 13px;" *ngIf="time">{{duration}}</span>
        <a (click)="userClickHandler()" class="user-feedback text-centered" *ngIf="userReactive">{{userFeedbackMsg}}</a>
    </div>
</div>